import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';
import { batchRequest } from '../../api/ApiService';

import { Loader } from 'react-loaders';

import Navigation from './components/navigation';
import Pagination from './components/pagination';

import ResultsAreInStep1 from './pages/results-are-in/step1';
import ResultsAreInStep2 from './pages/results-are-in/step2';
import ResultsAreInStep3 from './pages/results-are-in/step3';
import ResultsAreInStep4 from './pages/results-are-in/step4';
import ResultsAreInStep5 from './pages/results-are-in/step5';
import ResultsAreInStep6 from './pages/results-are-in/step6';

import MarketShareStep2 from './pages/feedback/market-share/step2';
import MarketShareStep3 from './pages/feedback/market-share/step3';
import MarketShareStep4 from './pages/feedback/market-share/step4';
import MarketShareStep5 from './pages/feedback/market-share/step5';
import MarketShareStep6 from './pages/feedback/market-share/step6';
import MarketShareStep7 from './pages/feedback/market-share/step7';
import MarketShareStep8 from './pages/feedback/market-share/step8';
import MarketShareStep9 from './pages/feedback/market-share/step9';
import MarketShareStep10 from './pages/feedback/market-share/step10';
import MarketShareStep11 from './pages/feedback/market-share/step11';
import MarketShareStep12 from './pages/feedback/market-share/step12';
import MarketShareStep13 from './pages/feedback/market-share/step13';
import MarketShareStep14 from './pages/feedback/market-share/step14';
import MarketShareStep15 from './pages/feedback/market-share/step15';
import MarketShareStep17 from './pages/feedback/market-share/step17';
import MarketShareStep18 from './pages/feedback/market-share/step18';
import MarketShareStep19 from './pages/feedback/market-share/step19';
import MarketShareStep20 from './pages/feedback/market-share/step20';
import MarketShareStep21 from './pages/feedback/market-share/step21';
import MarketShareStep22 from './pages/feedback/market-share/step22';
import MarketShareStep23 from './pages/feedback/market-share/step23';

import RevenuesStep2 from './pages/feedback/revenues/step2';
import RevenuesStep3 from './pages/feedback/revenues/step3';
import RevenuesStep4 from './pages/feedback/revenues/step4';

import GrossMarginsStep2 from './pages/feedback/gross-margins/step2';
import GrossMarginsStep3 from './pages/feedback/gross-margins/step3';
import GrossMarginsStep4 from './pages/feedback/gross-margins/step4';
import GrossMarginsStep5 from './pages/feedback/gross-margins/step5';
import GrossMarginsStep6 from './pages/feedback/gross-margins/step6';
import GrossMarginsStep7 from './pages/feedback/gross-margins/step7';

import SharePriceStep2 from './pages/feedback/share-price/step2';
import SharePriceStep3 from './pages/feedback/share-price/step3';
import SharePriceStep4 from './pages/feedback/share-price/step4';

import NetLossStep1 from './pages/feedback/net-loss/step1';
import NetLossStep2 from './pages/feedback/net-loss/step2';
import NetLossStep3 from './pages/feedback/net-loss/step3';

import RoeStep2 from './pages/feedback/roe/step2';
import RoeStep3 from './pages/feedback/roe/step3';
import RoeStep4 from './pages/feedback/roe/step4';

import RoaStep2 from './pages/feedback/roa/step2';
import RoaStep3 from './pages/feedback/roa/step3';
import RoaStep4 from './pages/feedback/roa/step4';

import EpsStep2 from './pages/feedback/eps/step2';
import EpsStep3 from './pages/feedback/eps/step3';
import EpsStep4 from './pages/feedback/eps/step4';

import CareerPathwayIntro from './pages/career-pathway/intro';
import CareerPathwayStep1 from './pages/career-pathway/step1';
import CareerPathwayStep2 from './pages/career-pathway/step2';
import CareerPathwayStep3 from './pages/career-pathway/step3';
import CareerPathwayStep4 from './pages/career-pathway/step4';
import CareerPathwayStep5 from './pages/career-pathway/step5';
import CareerPathwayStep6 from './pages/career-pathway/step6';

import GoodLuckStep1 from './pages/good-luck/step1';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 794px;
  background: #f5f6f7;
`;

class PerformanceFeedback extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      resultsTeamGrading: {},
      loaded: false,
      visitsHistory: []
    };
  }

  componentDidMount() {
    const { rounds } = this.props;
    const activeRound = this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const isRoundLive = round ? (
      round.is_started === true
      && round.is_finished === false
      && round.should_be_finished === false
    ) : false;

    if (isRoundLive) {
      changeLocation(`/onboarding`);
    } else {
      this.loadNavigation(() => {
        this.updateCurrentState();
      });
    }
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return roundInUrl || currentRound;
  }

  loadNavigation(callback) {
    const activeRound = this.activeRound;

    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/grading/?round_number=${activeRound}`,
    ]).then(res => {
      let showWellDone = false;
      let showUnderstandingPerformance = false;

      let performancePageConditions = [];

      const results = res[0].body.results || [];
      const resultsTeamGrading = res[1].body[0] || {};

      if (activeRound === 1 || activeRound === 2) {
        performancePageConditions = [
          'stock_price_grade',
          'market_share_grade',
          'revenues_grade',
          'gross_margin_grade',
        ];
      } else if (activeRound === 3) {
        performancePageConditions = [
          'revenues_grade',
          'gross_margin_grade',
          'roe_grade',
          'roa_grade',
        ];
      } else if (activeRound === 4) {
        performancePageConditions = [
          'roe_grade',
          'roa_grade',
          'earnings_per_share_grade',
          'stock_price_grade',
        ];
      }

      if (
        resultsTeamGrading[performancePageConditions[0]] === 1
        && resultsTeamGrading[performancePageConditions[1]] === 1
        && resultsTeamGrading[performancePageConditions[2]] === 1
        && resultsTeamGrading[performancePageConditions[3]] === 1
      ) {
        showWellDone = true;
      } else if (
        resultsTeamGrading[performancePageConditions[0]] === 1
        || resultsTeamGrading[performancePageConditions[1]] === 1
        || resultsTeamGrading[performancePageConditions[2]] === 1
        || resultsTeamGrading[performancePageConditions[3]] === 1
      ) {
        showUnderstandingPerformance = true;
      }

      const didNotSubmit = results.find(i => i.type.toLowerCase() === 'did not submit');
      const showDecisionsNotSubmitted = !!didNotSubmit;

      const insufficientCapital = results.find(i => i.type.toLowerCase() === 'insufficient capital');
      const showInsufficientCapital = !!insufficientCapital && !showDecisionsNotSubmitted;

      if (showDecisionsNotSubmitted || showInsufficientCapital) {
        showWellDone = false;
        showUnderstandingPerformance = false;
      }

      const foundMarketShareError1 = results.find(i => i.type.toLowerCase() === 'extended release date');
      const foundMarketShareError2 = results.find(i => i.type.toLowerCase() === 'minimum requirement failed');
      const foundMarketShareError3 = results.find(i => i.type.toLowerCase() === 'product market fit');
      const foundMarketShareError4 = results.find(i => i.type.toLowerCase() === 'awareness');
      const foundMarketShareError5 = results.find(i => i.type.toLowerCase() === 'place');
      const foundMarketShareError6 = results.filter(i => i.type.toLowerCase() === 'mobile overproduced' || i.type.toLowerCase() === 'auto overproduced');
      const foundMarketShareError7 = results.find(i => i.type.toLowerCase() === 'low inventory');
      const foundMarketShareError8 = results.find(i => i.type.toLowerCase() === 'low product ranking');

      const priceRangeFailed = results.find(i => i.type === "Price range failed");
      const showMarketShareStep2 = priceRangeFailed && !(didNotSubmit || insufficientCapital);

      const showMarketShareError1 = !!foundMarketShareError1;
      const showMarketShareError2 = !!foundMarketShareError2;
      const showMarketShareError3 = !!foundMarketShareError3;
      const showMarketShareError4 = !!foundMarketShareError4;
      const showMarketShareError5 = !!foundMarketShareError5;
      const showMarketShareError6 = !!foundMarketShareError6;
      const showMarketShareError7 = !!foundMarketShareError7;
      const showMarketShareError8 = !!foundMarketShareError8;
      let showMarketShare = false;
      if (activeRound === 1 || activeRound === 2) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showMarketShare = true;
        }
      }

      const foundRevenuesError = results.find(i => i.type.toLowerCase() === 'expected revenue low');
      const showRevenuesError = !!foundRevenuesError;
      let showRevenues = false;
      if (activeRound === 1 || activeRound === 2 || activeRound === 3) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showRevenues = true;
        }
      }

      const foundGrossMarginError1 = results.find(i => i.type.toLowerCase() === 'gross margin fail');
      const foundGrossMarginError2 = results.find(i => i.type.toLowerCase() === 'negative gross margins');
      const showGrossMarginError1 = !!foundGrossMarginError1 && !foundGrossMarginError2;
      const showGrossMarginError2 = !!foundGrossMarginError2;
      let showGrossMargin = false;
      if (activeRound === 1 || activeRound === 2 || activeRound === 3) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showGrossMargin = true;
        }
      }

      const foundSharePriceError = results.find(i => i.type.toLowerCase() === 'share price fail');
      const showSharePriceError = !!foundSharePriceError;
      let showSharePrice = false;
      if (activeRound === 1 || activeRound === 2 || activeRound === 4) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showSharePrice = true;
        }
      }

      const foundNetLossError = results.find(i => i.type.toLowerCase() === 'negative profits');
      const showNetLossError = !!foundNetLossError;
      let showNetLoss = false;
      if (activeRound >= 3) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        const found3 = results.find(i => i.type.toLowerCase() === 'negative profits');
        if (!found1 && !found2 && found3) {
          showNetLoss = true;
        }
      }

      const foundROEError = results.find(i => i.type.toLowerCase() === 'roe fail');
      const showROEError = !!foundROEError;
      let showROE = false;
      if (!showNetLoss && (activeRound === 3 || activeRound === 4)) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showROE = true;
        }
      }

      const foundROAError = results.find(i => i.type.toLowerCase() === 'roa fail');
      const showROAError = !!foundROAError;
      let showROA = false;
      if (!showNetLoss && (activeRound === 3 || activeRound === 4)) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showROA = true;
        }
      }

      let showEPSError = false;
      if (activeRound === 4) {
        const found = results.find(i => i.type.toLowerCase() === 'eps fail');
        if (found) {
          showEPSError = true;
        }
      }

      let showEPS = false;
      if (activeRound === 4) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showEPS = true;
        }
      }

      const navigation = [
        {
          title: 'Results Are In!',
          pattern: '/performance-feedback/results-are-in',
          steps: [
            ...(showInsufficientCapital ? [
              {
                url: '/performance-feedback/results-are-in/insufficient-capital',
                component: ResultsAreInStep1,
              },
            ] : []),
            ...(showDecisionsNotSubmitted ? [
              {
                url: '/performance-feedback/results-are-in/decisions-not-submitted',
                component: ResultsAreInStep2,
              },
            ] : []),
            ...(showWellDone ? [
              {
                url: '/performance-feedback/results-are-in/well-done',
                component: ResultsAreInStep3,
              },
            ] : []),
            ...(showUnderstandingPerformance ? [
              {
                url: '/performance-feedback/results-are-in/understanding-your-performance',
                component: ResultsAreInStep4,
              },
            ] : []),
            {
              url: '/performance-feedback/results-are-in/round-team-score',
              component: ResultsAreInStep5,
            },
            {
              url: '/performance-feedback/results-are-in/financial-goals',
              component: ResultsAreInStep6,
            },
          ],
        },
        {
          title: 'Feedback',
          pattern: '/performance-feedback/feedback',
          steps: [],
        },
        ...(showMarketShare ? [
          {
            parent: 'Feedback',
            title: 'Market Share',
            pattern: '/performance-feedback/market-share',
            steps: [
              ...(showMarketShareStep2 ? [
                {
                  url: '/performance-feedback/market-share/outside-price-range',
                  component: MarketShareStep2,
                }
              ] : []),
              ...(showMarketShareError1 ? [
                {
                  url: '/performance-feedback/market-share/release-date',
                  component: MarketShareStep3,
                  hasErrorAlert: true,
                },
              ] : []),
              ...(showMarketShareError2 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-no-customer',
                  component: MarketShareStep4,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/understand-the-customer',
                  component: MarketShareStep5,
                },
                {
                  url: '/performance-feedback/market-share/demand-issue-no-customer-research-and-investigate',
                  component: MarketShareStep6,
                },
              ] : []),
              ...(showMarketShareError3 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-small-market',
                  component: MarketShareStep7,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/product-market-fit',
                  component: MarketShareStep8,
                },
                {
                  url: '/performance-feedback/market-share/demand-issue-small-market-research-and-investigate',
                  component: MarketShareStep9,
                },
              ] : []),
              ...(showMarketShareError4 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-low-visibility',
                  component: MarketShareStep10,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/awareness-matters',
                  component: MarketShareStep11,
                },
                {
                  url: '/performance-feedback/market-share/demand-issue-low-visibility-research-and-investigate',
                  component: MarketShareStep12,
                },
              ] : []),
              ...(showMarketShareError5 ? [
                {
                  url: '/performance-feedback/market-share/channels',
                  component: MarketShareStep13,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/place',
                  component: MarketShareStep14,
                },
                {
                  url: '/performance-feedback/market-share/research-and-investigate',
                  component: MarketShareStep15,
                },
              ] : []),
              {
                url: '/performance-feedback/market-share/marketing-mix-research-and-investigate',
                component: MarketShareStep17,
              },
              ...(showMarketShareError6 ? [
                {
                  url: '/performance-feedback/market-share/overproduced',
                  component: MarketShareStep18,
                  hasErrorAlert: true,
                  performanceFeedbackData: foundMarketShareError6
                },
              ] : []),
              ...(showMarketShareError7 ? [
                {
                  url: '/performance-feedback/market-share/supply-issue',
                  component: MarketShareStep19,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/capacity-constraint',
                  component: MarketShareStep20,
                },
                {
                  url: '/performance-feedback/market-share/supply-issue-research-and-investigate',
                  component: MarketShareStep21,
                },
              ] : []),
              ...(showMarketShareError8 || false ? [ // hide this page for now since the backend needs to be adjusted
                {
                  url: '/performance-feedback/market-share/low-ranging-product',
                  component: MarketShareStep22,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/low-ranging-product-research-investigate',
                  component: MarketShareStep23,
                  hasErrorAlert: true,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showRevenues && showRevenuesError ? [
          {
            parent: 'Feedback',
            pattern: '/performance-feedback/revenues',
            title: 'Revenues',
            steps: [
              {
                url: '/performance-feedback/revenues/low-price',
                component: RevenuesStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/revenues/pricing-your-products',
                component: RevenuesStep3,
              },
              {
                url: '/performance-feedback/revenues/build-inventory',
                component: RevenuesStep4,
              },
            ],
          },
        ] : []),
        ...(showGrossMargin && (showGrossMarginError1 || showGrossMarginError2) ? [
          {
            parent: 'Feedback',
            title: 'Gross Margins',
            pattern: '/performance-feedback/gross-margins',
            steps: [
              ...(showGrossMarginError1 ? [
                {
                  url: '/performance-feedback/gross-margins/low-price-formula',
                  component: GrossMarginsStep2,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/gross-margins/low-price-unit-economics',
                  component: GrossMarginsStep3,
                },
                {
                  url: '/performance-feedback/gross-margins/low-price-research-and-investigate',
                  component: GrossMarginsStep4,
                },
              ] : []),
              ...(showGrossMarginError2 ? [
                {
                  url: '/performance-feedback/gross-margins/non-profit-formula',
                  component: GrossMarginsStep5,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/gross-margins/non-profit-unit-economics',
                  component: GrossMarginsStep6,
                },
                {
                  url: '/performance-feedback/gross-margins/non-profit-research-and-investigate',
                  component: GrossMarginsStep7,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showSharePrice && showSharePriceError ? [
          {
            parent: 'Feedback',
            title: 'Share Price',
            pattern: '/performance-feedback/share-price',
            steps: [
              {
                url: '/performance-feedback/share-price/formula',
                component: SharePriceStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/share-price/excess-share-issuance',
                component: SharePriceStep3,
              },
              {
                url: '/performance-feedback/share-price/research-and-investigate',
                component: SharePriceStep4,
              },
            ],
          },
        ] : []),
        ...(showNetLoss ? [
          {
            parent: 'Feedback',
            title: 'Net Loss',
            pattern: '/performance-feedback/net-loss',
            steps: [
              {
                url: '/performance-feedback/net-loss/stats',
                component: NetLossStep1,
              },
              ...(showNetLossError ? [
                {
                  url: '/performance-feedback/net-loss/profit',
                  component: NetLossStep2,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/net-loss/research-and-investigate',
                  component: NetLossStep3,
                  hasErrorAlert: true,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showROE && showROEError ? [
          {
            parent: 'Feedback',
            title: 'Return on Equity',
            pattern: '/performance-feedback/roe',
            steps: [
              {
                url: '/performance-feedback/roe/formula',
                component: RoeStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/roe/return-on-investments',
                component: RoeStep3,
              },
              {
                url: '/performance-feedback/roe/research-and-investigate',
                component: RoeStep4,
              },
            ],
          },
        ] : []),
        ...(showROA && showROAError ? [
          {
            parent: 'Feedback',
            title: 'Return on Assets',
            pattern: '/performance-feedback/roa',
            steps: [
              {
                url: '/performance-feedback/roa/formula',
                component: RoaStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/roa/return-on-investments',
                component: RoaStep3,
              },
              {
                url: '/performance-feedback/roa/research-and-investigate',
                component: RoaStep4,
              },
            ],
          },
        ] : []),
        ...(showEPS && showEPSError ? [
          {
            parent: 'Feedback',
            title: 'Earnings Per Share',
            pattern: '/performance-feedback/eps',
            steps: [
              {
                url: '/performance-feedback/eps/formula',
                component: EpsStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/eps/return-on-investments',
                component: EpsStep3,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/eps/research-and-investigate',
                component: EpsStep4,
                hasErrorAlert: true,
              },
            ],
          },
        ] : []),
        ...(activeRound < 4 ? [
          {
            title: 'Career Pathway',
            pattern: '/performance-feedback/career-pathway',
            steps: [
              {
                url: '/performance-feedback/career-pathway/intro',
                component: CareerPathwayIntro,
              },
              ...(activeRound === 1 ? [
                {
                  url: '/performance-feedback/career-pathway/product-marketing',
                  component: CareerPathwayStep1,
                },
                {
                  url: '/performance-feedback/career-pathway/product-marketing-links',
                  component: CareerPathwayStep2,
                },
              ] : []),
              ...(activeRound === 2 ? [
                {
                  url: '/performance-feedback/career-pathway/supply-chain',
                  component: CareerPathwayStep3,
                },
                {
                  url: '/performance-feedback/career-pathway/supply-chain-links',
                  component: CareerPathwayStep4,
                },
              ] : []),
              ...(activeRound === 3 ? [
                {
                  url: '/performance-feedback/career-pathway/finance-accounting',
                  component: CareerPathwayStep5,
                },
                {
                  url: '/performance-feedback/career-pathway/finance-accounting-links',
                  component: CareerPathwayStep6,
                },
              ] : []),
            ],
          },
        ] : []),
        {
          title: 'Good Luck!',
          pattern: '/performance-feedback/good-luck',
          steps: [
            {
              url: '/performance-feedback/good-luck',
              component: GoodLuckStep1,
            },
          ],
        },
      ];

      if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
        this.setState({
          navigation,
          resultsTeamGrading,
          loaded: true,
        }, () => {
          if (callback) {
            callback();
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    })
      .catch(err => { });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    let currentCategory = 0;
    let currentStep = 0;
    for (let i = 0; i < navigation.length; i++) {
      const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
      if (stepIndex > -1) {
        currentCategory = i;
        currentStep = stepIndex;
        break;
      }
    }

    if (
      currentCategory !== this.state.currentCategory
      || currentStep !== this.state.currentStep
    ) {

      this.setState({
        currentCategory,
        currentStep,
      }, () => {
        this.checkLocation();
      });
    } else {
      if (this.props.location.pathname === '/performance-feedback') {
        this.checkLocation();
      }
    }
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;

    const roundInPath = this.props.location.query.round;
    let roundChange = false;
    if (roundInPath && Number(roundInPath) !== Number(activeRound)) {
      roundChange = true;
    }

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url && !roundChange) {
      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      visitsHistory,
      resultsTeamGrading
    } = this.state;
    const { rounds } = this.props;
    const activeRound = this.activeRound;

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    const category = navigation[currentCategory];
    let Component = null;
    let previousShownErrors = 0;
    let performanceFeedbackData = null;
    if (category) {
      Component = category.steps[currentStep].component;

      const url = category.steps[currentStep].url;
      const allSteps = navigation.reduce((prev, curr) => ([
        ...prev,
        ...curr.steps,
      ]), []);

      const currentStepIndex = allSteps.findIndex(i => i.url === url);
      previousShownErrors = allSteps.slice(0, currentStepIndex).filter(i => i.hasErrorAlert === true).length;
      performanceFeedbackData = category.steps[currentStep].performanceFeedbackData;
    }

    return (
      <Wrapper>
        <Navigation
          data={navigation}
          category={currentCategory}
          visitsHistory={visitsHistory}
          activeRound={activeRound}
          removeEngagement={true}
        />
        <Content>
          <ContentWrapper>
            {Component && (
              <Component
                activeRound={activeRound}
                rounds={rounds}
                previousShownErrors={previousShownErrors}
                resultsTeamGrading={resultsTeamGrading}
                performanceFeedbackData={performanceFeedbackData}
              />
            )}
          </ContentWrapper>
          <Pagination
            goNext={this.goNext}
            goPrev={this.goPrev}
            isFirstStep={this.isFirstStep}
            isLastStep={this.isLastStep}
            currentStep={currentStep + 1}
            countOfSteps={this.countOfSteps}
          />
        </Content>
      </Wrapper>
    );
  }

}

export default PerformanceFeedback;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/index.js